module.exports = __webpack_public_path__ + "static/media/abacus.c5162758.svg";